import type { ConfirmationButton } from '@shared/components/confirmation-dialog/confirmation-dialog.component';

export type WarehouseListDialogI18nPrefix =
  | 'logical_warehouse'
  | 'virtual_warehouse';

type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

export function buildWarehouseDeleteDialogState(
  translate: TranslateFn,
  prefix: WarehouseListDialogI18nPrefix,
  warehouseName: string,
): {
  title: string;
  message: string;
  buttons: ConfirmationButton[];
} {
  return {
    title: translate(`${prefix}.dialog.confirm_delete.title`),
    message: translate(`${prefix}.dialog.confirm_delete.message`, {
      warehouseName,
    }),
    buttons: [
      {
        label: translate(`${prefix}.dialog.actions.cancel`),
        severity: 'secondary',
        action: 'cancel',
      },
      {
        label: translate(`${prefix}.dialog.actions.delete`),
        severity: 'danger',
        action: 'confirm',
      },
    ],
  };
}

/**
 * @param useDialogActionLabels — Kho ảo page uses dialog.actions.* for labels;
 *   logical + kho logic use actions.* for status confirm labels.
 */
export function buildWarehouseStatusChangeDialogState(
  translate: TranslateFn,
  prefix: WarehouseListDialogI18nPrefix,
  warehouseName: string,
  activate: boolean,
  useDialogActionLabels: boolean,
): {
  title: string;
  message: string;
  buttons: ConfirmationButton[];
} {
  const action = activate ? 'activate' : 'deactivate';
  const labelKey = useDialogActionLabels
    ? `${prefix}.dialog.actions.${action}`
    : `${prefix}.actions.${action}`;
  const actionLabel = translate(labelKey);

  return {
    title: translate(`${prefix}.dialog.confirm_status_change.title`),
    message: translate(`${prefix}.dialog.confirm_status_change.message`, {
      action: actionLabel,
      warehouseName,
    }),
    buttons: [
      {
        label: translate(`${prefix}.dialog.actions.cancel`),
        severity: 'secondary',
        action: 'cancel',
      },
      {
        label: translate(labelKey),
        severity: activate ? 'success' : 'danger',
        action: 'confirm',
      },
    ],
  };
}
